<ng-container *ngIf="formPrincipal">
  <div class="card-header">
    <div class="title-section">
      <h2 class="header-title">{{ modelRecived ? 'Editar Gastos' : 'Agregar Gastos' }}</h2>
    </div>
    <div class="search-section">
      <div class="button-section">
        <button class="btn-new" mat-raised-button color="accent" appPermissionControl="P138B0002" (click)="modelRecived ? update(form.value) : create(form.value)">
          <mat-icon>save</mat-icon>
          {{ modelRecived ? 'Actualizar' : 'Guardar' }}
        </button>
        <button class="btn-cancel" type="button" mat-raised-button (click)="close()" appPermissionControl="P138B0001"><mat-icon>arrow_back</mat-icon>Cancelar</button>
      </div>
    </div>
  </div>

  <form class="mt-5" [formGroup]="form" (submit)="modelRecived ? update(form.value) : create(form.value)" appPermissionControl="P138F0001">
    <div class="form-row">
      <!-- Variable -->
      <div class="form-field" color="accent" appearance="outline">
        <label>Variable Id</label>
        <input id="numVar" class="form-control" formControlName="numVar" type="number" [readonly]="modelRecived" required appPermissionControl="P138K0001" />
      </div>

      <!-- Descripcion -->
      <div class="form-field" color="accent" appearance="outline">
        <label>Descripción</label>
        <input class="form-control" formControlName="descripcion" type="text" required appPermissionControl="P138K0002" />
      </div>

      <!-- Concepto -->
      <div class="form-field" color="accent" appearance="outline">
        <label>Concepto</label>
        <select class="form-control" formControlName="concepto" required appPermissionControl="P138K0003">
          <option value>-- Seleccione --</option>
          <option *ngFor="let concepto of conceptos" [value]="concepto.concepto">{{ concepto.concepto }} | {{ concepto.descripcion }}</option>
        </select>
      </div>

      <!-- Factor -->
      <div class="form-field" color="accent" appearance="outline">
        <label>Factor</label>
        <select class="form-control" formControlName="claveTasa" required appPermissionControl="P138K0004">
          <option value>-- Seleccione --</option>
          <option *ngFor="let tasa of tasas" [value]="tasa.clave">{{ tasa.clave }} | {{ tasa.descripcion }}</option>
        </select>
      </div>

      <!-- Periodo de Gracia -->
      <div class="form-field" color="accent" appearance="outline">
        <label>Periodo de Gracia</label>
        <input class="form-control" placeholder="123" formControlName="gracePeriod" type="number" appPermissionControl="P138K0005" />
      </div>

      <!-- Calcular -->
      <div class="form-field" color="accent" appearance="outline">
        <label>Calcular</label>
        <select class="form-control" formControlName="calculate" appPermissionControl="P138K0006">
          <option value>-- Seleccione --</option>
          <option *ngFor="let element of calculate" [value]="element.iValor">{{ element.iValor }} | {{ element.sEtiqueta }}</option>
        </select>
      </div>

      <!-- Aplicar -->
      <div class="form-field" color="accent" appearance="outline">
        <label>Aplicar</label>
        <select class="form-control" formControlName="aplicate" appPermissionControl="P138K0007">
          <option value>-- Seleccione --</option>
          <option *ngFor="let element of aplicate" [value]="element.iValor">{{ element.iValor }} | {{ element.sEtiqueta }}</option>
        </select>
      </div>

      <!-- Aplicar a -->
      <div class="form-field" color="accent" appearance="outline">
        <label>Aplicar a</label>
        <select class="form-control" formControlName="aplicateTo" appPermissionControl="P138K0008">
          <option value>-- Seleccione --</option>
          <option *ngFor="let element of aplicateTo" [value]="element.iValor">{{ element.iValor }} | {{ element.sEtiqueta }}</option>
        </select>
      </div>

      <!-- Daily -->
      <div class="form-field" color="accent" appearance="outline">
        <label>Daily</label>
        <select class="form-control" formControlName="daily" appPermissionControl="P138K0009">
          <option value>-- Seleccione --</option>
          <option *ngFor="let element of daily" [value]="element.iValor">{{ element.iValor }} | {{ element.sEtiqueta }}</option>
        </select>
      </div>
    </div>

    <div class="form-row">
      <!-- Mínimo -->
      <div class="form-field" color="accent" appearance="outline">
        <label>Mínimo</label>
        <input class="form-control" formControlName="valorFijo" type="number" required appPermissionControl="P138K0010" />
      </div>

      <!-- Fijado -->
      <div class="form-field" color="accent" appearance="outline">
        <label>Fijado</label>
        <input class="form-control" formControlName="fixed" type="number" appPermissionControl="P138K0011" />
      </div>

      <!-- % de Impuestos -->
      <div class="form-field" color="accent" appearance="outline">
        <label>% de Impuestos</label>
        <input class="form-control" formControlName="porcentaje" type="number" required appPermissionControl="P138K0012" />
      </div>

      <!-- Concepto -->
      <div class="form-field" color="accent" appearance="outline">
        <label>Concepto</label>
        <select class="form-control" formControlName="conceptoAdicional" appPermissionControl="P138K0013">
          <option value>-- Seleccione --</option>
          <option *ngFor="let concepto of conceptos" [value]="concepto.concepto">{{ concepto.concepto }} | {{ concepto.descripcion }}</option>
        </select>
      </div>

      <!-- Calcular -->
      <div class="form-field" color="accent" appearance="outline">
        <label>Calcular</label>
        <select class="form-control" formControlName="calculate2" appPermissionControl="P138K0014">
          <option value>-- Seleccione --</option>
          <option *ngFor="let element of calculate2" [value]="element.iValor">{{ element.iValor }} | {{ element.sEtiqueta }}</option>
        </select>
      </div>
    </div>
  </form>
</ng-container>
